const starsScore = (rate) => {
    let num = Math.floor(rate)
    return "★★★★★".slice(0,(num/2))
}

export default starsScore;